<!-- TODO: This file is getting too big. Consider splitting real content,
errors, and loading states into separate files -->

@let tenant = meFeature.contexts.selectors.tenant.asSignal();
@let zone = meFeature.contexts.selectors.zone.asSignal();
@let apps = appsSg();

@let isLoading = meFeature.selectors.isLoading.asSignal();
@let error = meFeature.selectors.error.asSignal();
@let zoneId = meFeature.contexts.selectors.zoneId.asSignal();
@let appsResult =
  zoneId
    ? meFeature.zoneApps.selectors.getResult(zoneId).asSignal()
    : undefined;
@let isLoadingApps = zoneId ? !appsResult?.isSettled : false;
@let appsError = appsResult?.error;

<div class="atn-home">
  @defer (when !isLoading) {
    @if (tenant && zone) {
      <!-- Header -->
      <div class="atn-home__header">
        <div
          class="atn-home__header--tenant"
          data-test-id="tenantHeader"
        >
          Welcome to <b>{{ tenant?.name }}</b
          >'s Attain Apps platform!
        </div>
        <div
          class="atn-home__header--zone"
          data-test-id="zoneHeader"
        >
          You are currently in the <b>{{ zone?.name }}</b> zone
        </div>
      </div>

      @if (isLoadingApps) {
        <!-- Apps loader -->
        <div class="atn-home__loader-container">
          <div class="atn-home__apps-loader">
            <atn-ds-loader
              type="page"
              message="Loading apps..."
            />
          </div>
        </div>
      } @else if (apps && apps.length) {
        <div class="atn-home__apps">
          @for (app of apps; track app?.id) {
            @if (app) {
              <a
                class="atn-home__app"
                [atnPlatformNavigationLink]="
                  meFeature.contexts.selectors.getUrlForApp({ app }).asSignal()
                "
              >
                <i
                  class="atn-home__app-icon atn-icon atn-{{
                    app.icon
                  }} atn-blue"
                ></i>
                <h3>{{ app.name }}</h3>
                <p class="atn-home__app-desc">{{ app.description }}</p>
              </a>
            }
          }
        </div>
      } @else if (appsError) {
        <!-- Error loading apps -->
        <div class="atn-home__empty-state-container">
          <div class="atn-home__empty-state-content">
            <atn-ds-empty-state
              type="error"
              title="Uh oh! Something went wrong"
              [description]="
                'Our system is yelling at us: &quot;' +
                appsError +
                '&quot; Maybe just try refreshing the page?'
              "
              action="Refresh"
              (action)="refreshAppsBtnClickHandler()"
              layout="v"
            />
          </div>
        </div>
      } @else {
        <!-- No apps available -->
        <div class="atn-home__empty-state-container">
          <div class="atn-home__empty-state-content">
            <atn-ds-empty-state
              type="no-data"
              title="You don't have access to any of our wonderful applications!"
              description="Try refreshing the page in a minute or two. If the problem persists, your administrator likely hasn't given you access to any apps."
              action="Refresh"
              (action)="refreshAppsBtnClickHandler()"
              layout="v"
            />
          </div>
        </div>
      }
    } @else {
      <!-- No access to tenant or zone -->
      <div class="atn-home__empty-state-container">
        <div class="atn-home__empty-state-content">
          <atn-ds-empty-state
            type="no-data"
            title="You don't have access to this tenant or zone!"
            [description]="
              error?.toString() ??
              'Try refreshing the page in a minute or two. If the problem persists, your administrator likely hasn\'t given you access to this tenant or zone.'
            "
            action="Refresh"
            (action)="refreshAccessBtnClickHandler()"
            layout="v"
          />
        </div>
      </div>
    }
  } @loading (minimum 200) {
    <!-- Tenant & zone loader -->
    <div class="atn-home__loader-container">
      <div class="atn-home__loader">
        <atn-ds-loader
          type="page"
          message="Loading tenant and zone..."
        />
      </div>
    </div>
  }
</div>
